// extracted by mini-css-extract-plugin
export default {"h0":"title_h0__yABuZ","h1":"title_h1__A7tgV","h2":"title_h2__GNYMW","h3":"title_h3__IhjYl","h4":"title_h4__zg6ea"};